import { useFormattingSeconds } from "@src/hooks/useFormattingSeconds";
import AddIcon from "@assets/img/plus-icon.svg";
import TableActionButton, {
  TableActionButtonContainer,
} from "../TableComponent/TableActionButton";
import { useMemo } from "react";
import { ITrack } from "@src/types/track";
import PlayButton from "../MusicPlayer/PlayButton";
import { ITrackStatus } from "@src/redux/slices/trackPlayerSlice";
import Tooltip from "../Tooltip";

export const existingTracksColumns = ({
  onAddTrackToPlaylist,
  onPlayTrack,
  currentTrack,
  trackStatus,
}: {
  onAddTrackToPlaylist: (track: ITrack) => void;
  onPlayTrack: (track: ITrack) => void;
  currentTrack?: ITrack | null;
  trackStatus?: ITrackStatus;
}) =>
  useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Artist",
        accessor: "artist",
      },
      {
        Header: "Album",
        accessor: "album",
      },
      {
        Header: "Label",
        accessor: "label",
      },
      {
        Header: "Duration",
        accessor: "duration",

        Cell: ({ value }: { value: number }): React.JSX.Element => {
          if (value) {
            const { formatted } = useFormattingSeconds(value);
            return <span>{formatted}</span>;
          }
          return <span>00:00:00</span>;
        },
      },
      {
        Header: "Player",
        accessor: "audio.url",
        Cell: ({ row }: { row: ITrack }): React.JSX.Element => (
          <PlayButton
            loading={
              currentTrack?.documentId === row.documentId &&
              trackStatus === "loading"
            }
            isPlaying={
              currentTrack?.documentId === row.documentId &&
              trackStatus === "playing"
            }
            onClick={() => onPlayTrack(row)}
          />
        ),
        width: "70px",
        minWidth: "60px",
        maxWidth: "90px",
      },
      {
        Header: "Actions",
        accessor: "actions",

        centerContent: true,
        Cell: ({ row }: { row: ITrack }): React.JSX.Element => {
          const line = (label: string, items?: { title?: string }[]) =>
            items?.length
              ? `${label}: ${items
                  .map((i) => i?.title)
                  .filter(Boolean)
                  .join(", ")}`
              : null;

          const content =
            [line("Tags", row?.tags), line("Moods", row?.moods)]
              .filter(Boolean)
              .join(" • ") || "This track has no tags or moods";

          return (
            <Tooltip
              contentStyle={{
                maxWidth: "200px",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
              content={content}
            >
              <TableActionButtonContainer style={{ justifyContent: "center" }}>
                <TableActionButton
                  alt="add"
                  iconSrc={AddIcon}
                  onClick={() => onAddTrackToPlaylist(row)}
                />
              </TableActionButtonContainer>
            </Tooltip>
          );
        },
      },
    ],
    [onAddTrackToPlaylist, onPlayTrack, currentTrack, trackStatus]
  );
